import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const UserManual = () => {

  const pdfPath = "/images/Usear_manulworkflow.pdf"; 


  return (
    <Box p={3}>
      {/* Title */}
      {/* <Typography variant="h5" fontWeight="bold" mb={2}>
        User Manual
      </Typography> */}

      {/* PDF Viewer */}
      <Paper elevation={3} sx={{ p: 2 }}>
        <iframe
          src={pdfPath}
          title="User Manual PDF"
          width="100%"
          height="900px"
          style={{
            border: "none",
            borderRadius: "8px"
          }}
        />
      </Paper>
    </Box>
  );
};

export default UserManual;